// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3459":"a73e7544012be05b","4804":"c2e02cbcae6293ac"}[chunkId] + ".css";
};